// extracted by mini-css-extract-plugin
module.exports = {"columnsSm":"5","columnsMd":"7","columnsLg":"9","marginSm":"20px","marginMd":"48px","marginLg":"0","maxGridWidth":"1530px"};